module.exports = __webpack_public_path__ + "img/image44.09030e17.png";